export default __webpack_public_path__ + "static/media/3132 spice rack B side.ddcc2d4e.png";